import { compose } from '../../../../src/web/utils/react';
import { widget } from '../../../../src/web/components/widgets/decorators';
import { BUILDER } from '../../../../src/shared/abilities';
import { NAME, ID } from './properties';
import PopUp from './PopUp';

const component = compose(
  widget(
    { name: NAME, deprecated: true, componentId: ID },
    {
      menu: { items: ['edit'], disallowWidgetSwitching: true },
    },
  ),
)(PopUp);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
